/* eslint-disable */
// @ts-nocheck

import React, { useContext } from 'react'

import FileInput from '../../../components/forms/FileInput'
import Button from '../../../components/misc/Button'
import MultipleDrop from '../../../components/misc/Images/MultipleDrop'
import { ProductContext } from '../../../containers/products/newProductModal/NewWizardContainer'

const ProductImg = () => {
  const { control, stepDown } = useContext(ProductContext)
  return (
    <>
      <div className="h-96 overflow-auto rounded border border-slate-300 p-2 scrollbar-thin">
        <div className="w-full">
          <MultipleDrop control={control} name="images" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 py-2">
        <Button
          action={stepDown}
          color="slate-500"
          full
          name="Atrás"
          outline
          textColor="slate-600"
        />
        <Button color="slate-600" full name="Siguiente" type="submit" />
      </div>
    </>
  )
}

export default ProductImg
